'use strict'

// import { create } from '@symbo.ls/create'
// import { ComponentsPage } from '@symbo.ls/preview'
// import Editorjs from '../packages/plugins/Editorjs'

// create({
//   state: {
//     globalTheme: 'dark'
//   }
// }, {
//   pages: {
//     '/': {
//       box: {
//         extend: Editorjs,
//         $editorjs: [{
//           id: 'k5OwVLgA2l',
//           type: 'header',
//           data: {
//             text: 'Proposal',
//             level: 1,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'Pv9l-lZxG0',
//           type: 'paragraph',
//           data: {
//             text: 'In line with the brand requirement of Kaveri Drinks, we, at Symbols, have made the decision to allocate a dedicated team to ensure its successful completion. This team will be involved in every facet of the launch process. The provided proposal comprehensively addresses all aspects, encompassing product costs, delivery estimates, and options for both the basic and advanced versions of the website. These options include both one-time payment and subscription-based models.'
//           }
//         },
//         {
//           id: 'yvjeuRzPje',
//           type: 'header',
//           data: {
//             text: '1. Offer',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'hMVCEY7238',
//           type: 'paragraph',
//           data: {
//             text: 'We propose a complete overhaul and development of your brand\'s website, starting from the foundation. This approach encompasses all the essential elements necessary for a successful launch, including design, software, and user experience. Being an integral part of the Symbols platform, we provide a comprehensive all-in-one solution for both the development and ongoing maintenance of the website. Additionally, we enable you to independently manage content and design aspects in the future.',
//             level: 6,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'wLUFJXtyGH',
//           type: 'paragraph',
//           data: {
//             text: 'As part of the offer, we will use Slack, WhatsApp and email as communication tools. You can also visit us in the <a href="https://discord.com/invite/crdFSkapFY">Discord channel</a> to have direct access to each member of the team. Upon request, you will be able to follow weekly updates.',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'poiR2I8PID',
//           type: 'header',
//           data: {
//             text: '2. Design',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'ksuPHaAWdF',
//           type: 'paragraph',
//           data: {
//             text: 'To bring the product to the fore, we offer a minimal load on the visual side of the site using more white space (negative space). Accordingly, we can use only those important elements of the brand, which make the appearance of the website distinctive and memorable.&nbsp;'
//           }
//         },
//         {
//           id: '5Y9fFefPED',
//           type: 'paragraph',
//           data: {
//             text: 'It would give it more aesthetics and contrast to highlight what’s the most important. As content is small, composition could be spread all across the device screen. Simple, clean design with little effects to CTA or other important content would be efficient.',
//             level: 5,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'DDfvPOuPVL',
//           type: 'header',
//           data: {
//             text: '2.1. User Interface',
//             level: 5,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'CiXo_O-mjT',
//           type: 'paragraph',
//           data: {
//             text: 'Despite the minimalism, to make the website diverse while maintaining consistency, we create a highly functional design system that effectively translates your branding into a visual, manageable site system. Every aspect of UI in place make the website functional and form user interaction accessible to easily purchase the product.',
//             level: 5,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'ipAENAD_6T',
//           type: 'header',
//           data: {
//             text: '2.2. Graphics, Illustrations and 3D',
//             level: 5,
//             alignment: 'left'
//           }
//         },
//         {
//           id: '4tdlzf4zNk',
//           type: 'paragraph',
//           data: {
//             text: 'Another possibility is to incorporate elements like 360-degree views or 3D enhancements. This would impart a spatial dynamism to the website, providing users with a tangible sense of the bottle\'s physical presence.',
//             level: 5,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'TtOy6J4aLy',
//           type: 'header',
//           data: {
//             text: '2.3. Imagery',
//             level: 5,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'L93sfoTRlA',
//           type: 'paragraph',
//           data: {
//             text: 'Apart from graphics, we have the option to incorporate images that offer users an enhanced perception of the products. These images could encompass white backgrounds, compositions, or scenes featuring individuals and memories associated with the beverage.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'wEizB9Y3zs',
//           type: 'header',
//           data: {
//             text: '2.4. Animations and Motion',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'tc0l2L6Wlb',
//           type: 'paragraph',
//           data: {
//             text: 'Whether the graphics are 2D or 3D, our objective is to attain a seamless motion on the website that mirrors the ongoing progression of the brand. This dynamic approach not only reflects the brand\'s continuous evolution but also adds an element of enjoyment to the website\'s usability.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'bvtB6V6kcC',
//           type: 'header',
//           data: {
//             text: '2.5. Accessibility',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: '-fg6EpdoXp',
//           type: 'paragraph',
//           data: {
//             text: 'Our primary aspiration and objective revolve around ensuring the website\'s accessibility to all, regardless of disabilities. We will offer immediate technical support for your website following its launch, and we are also working towards introducing a similar facet on the Symbols platform in the foreseeable future.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'p4_OOgKLyN',
//           type: 'header',
//           data: {
//             text: '2.6. References',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'q1G9e77o41',
//           type: 'paragraph',
//           data: {
//             text: '<b>2.5.1.</b>&nbsp;Website references we\'re following:',
//             style: 'unordered',
//             items: [
//               'https://botivodrinks.com/&nbsp;',
//               '<a href="https://pensadormezcal.com/">https://pensadormezcal.com/</a>&nbsp;',
//               '<a href="https://quarterproof.com/">https://quarterproof.com/</a>',
//               '<a href="https://avecdrinks.com/">https://avecdrinks.com/</a>&nbsp;',
//               '<a href="https://woodenspoonherbs.com/">https://woodenspoonherbs.com/</a>&nbsp;',
//               '<a href="https://drinkghia.com/">https://drinkghia.com/</a>&nbsp;',
//               '<a href="https://www.jojowhiskey.com/">https://www.jojowhiskey.com/</a>&nbsp;',
//               '<a href="https://bellinicanella.com/">https://bellinicanella.com/</a>&nbsp;',
//               '<a href="https://decemdrinks.com/">https://decemdrinks.com/</a>&nbsp;',
//               '<a href="https://adventuristspirits.com/">https://adventuristspirits.com/</a>&nbsp;'
//             ]
//           }
//         },
//         {
//           id: '3WSUS4r78G',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               'https://botivodrinks.com',
//               '<a href="https://pensadormezcal.com/">https://pensadormezcal.com/</a>&nbsp;',
//               '<a href="https://quarterproof.com/">https://quarterproof.com/</a>',
//               '<a href="https://avecdrinks.com/">https://avecdrinks.com/</a>&nbsp;',
//               '<a href="https://woodenspoonherbs.com/">https://woodenspoonherbs.com/</a>&nbsp;',
//               '<a href="https://drinkghia.com/">https://drinkghia.com/</a>&nbsp;',
//               '<a href="https://www.jojowhiskey.com/">https://www.jojowhiskey.com/</a>&nbsp;',
//               '<a href="https://bellinicanella.com/">https://bellinicanella.com/</a>&nbsp;',
//               '<a href="https://decemdrinks.com/">https://decemdrinks.com/</a>&nbsp;',
//               '<a href="https://adventuristspirits.com/">https://adventuristspirits.com/</a>&nbsp;'
//             ],
//             text: '<b>2.5.2.</b> Inclusions of references enhanced with advanced graphics and motion:'
//           }
//         },
//         {
//           id: 'MmocA5beeP',
//           type: 'paragraph',
//           data: {
//             text: '<b>2.5.2.</b> Inclusions of references enhanced with advanced graphics and motion:',
//             style: 'unordered',
//             items: [
//               '<a href="https://www.drpepper.ca/en/">https://www.drpepper.ca/en/</a>&nbsp;',
//               '<a href="https://www.tenutasantapollonia.it/">https://www.tenutasantapollonia.it/</a>&nbsp;',
//               '<a href="https://hotelodisej.com/">https://hotelodisej.com/</a>&nbsp;',
//               '<a href="https://brewsandgrooves.com/manifesto">https://brewsandgrooves.com/manifesto</a>&nbsp;',
//               '<a href="https://en.puiatti.com/method/">https://en.puiatti.com/method/</a>&nbsp;',
//               '<a href="https://bullesderuche.fr/en/">https://bullesderuche.fr/en/</a>&nbsp;'
//             ]
//           }
//         },
//         {
//           id: '8sy-oihAw3',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               '<a href="https://www.drpepper.ca/en/">https://www.drpepper.ca/en/</a>&nbsp;',
//               '<a href="https://www.tenutasantapollonia.it/">https://www.tenutasantapollonia.it/</a>&nbsp;',
//               '<a href="https://hotelodisej.com/">https://hotelodisej.com/</a>&nbsp;',
//               '<a href="https://brewsandgrooves.com/manifesto">https://brewsandgrooves.com/manifesto</a>&nbsp;',
//               '<a href="https://en.puiatti.com/method/">https://en.puiatti.com/method/</a>&nbsp;',
//               '<a href="https://bullesderuche.fr/en/">https://bullesderuche.fr/en/</a>&nbsp;'
//             ],
//             text: '2.7. User Experience (UX)',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'lbYskiNIaj',
//           type: 'header',
//           data: {
//             text: '2.7. User Experience (UX)',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'Gy2df1YLQA',
//           type: 'paragraph',
//           data: {
//             text: 'Our goal is not only the implementation of the project, our goal is its success. As part of the design, we conduct tests on people who we consider to be the best potential users of the website. We set goals for the project, track and compare how user behaviour matches our initial design and conceptual ideas. On demand, we conduct in-person surveys and use A/B iterations to improve usability. We don\'t cut ties even after the deal is completed and stay in touch for positive iterations and brainstorming new ideas.',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'la74YAIfKp',
//           type: 'header',
//           data: {
//             text: '3. Programming',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'uDw8OANoWR',
//           type: 'header',
//           data: {
//             text: '3.1. Used technologies',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'p1bZ5XdxOh',
//           type: 'paragraph',
//           data: {
//             text: 'We create an ecosystem and use Javascript in the frontend and backend part. We have created several libraries for efficient site creation that are openly available on <a href="https://github.com/symbo-ls" target="_blank">Github</a> and in <a href="https://symbols.app/developers" target="_blank">our documentation</a>.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'IKki2r8SHz',
//           type: 'header',
//           data: {
//             text: '3.2. Frontend',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: '7Kfd_xMPsl',
//           type: 'paragraph',
//           data: {
//             text: 'The works created on the symbols are used with exceptional speed and flexibility. We have our own Front-end ecosystem, which we have been using for years in many projects.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: '3oJo4SU2LR',
//           type: 'header',
//           data: {
//             text: '3.3. Responsive',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'afvfzuqzKX',
//           type: 'paragraph',
//           data: {
//             text: 'Symbols allows you to use the website in all known devices and browsers, regardless of screen size and operating system.',
//             style: 'unordered',
//             items: [
//               'Dimensions: from iPhone SE (320x480) to iMac 27’(2560× 1440) and up.',
//               'Input sources: Mouse (and/or Keyboard), touchscreens',
//               'Accessible for people with disabilities',
//               'Widely used browsers that are still in production and use:'
//             ]
//           }
//         },
//         {
//           id: 'pFuetW-WFo',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               'Dimensions: from iPhone SE (320x480) to iMac 27’(2560× 1440) and up.',
//               'Input sources: Mouse (and/or Keyboard), touchscreens',
//               'Accessible for people with disabilities',
//               'Widely used browsers that are still in production and use:',
//               'Brave',
//               'Stack Browser',
//               'Arc Browser and others'
//             ]
//           }
//         },
//         {
//           id: 'MNrlS8TBM1',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               'Chrome',
//               'Internet Explorer Edge',
//               'Firefox',
//               'Safari',
//               'Brave',
//               'Stack Browser',
//               'Arc Browser and others'
//             ],
//             text: '3.4. Backend',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: '3YtISZJTVf',
//           type: 'header',
//           data: {
//             text: '3.4. Backend',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'X0GBUMdOKW',
//           type: 'paragraph',
//           data: {
//             text: 'We use AWS and Google Cloud secure systems for server infrastructure. In terms of backend. Our partner is based.io, which provides Eurovision\'s live voting system, and our team members have also contributed in the past. It provides, on the one hand, the fastest connection to the database, and on the other hand, stability during approximately half billion secure parallel requests from the user. In addition, the site is protected from DDoS and other attacks through Cloudflare, which avoids more than 50% additional server costs.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'InxkkjFs9T',
//           type: 'header',
//           data: {
//             text: '3.5. Payments and delivery',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'PTBV1UV0aK',
//           type: 'paragraph',
//           data: {
//             text: 'We use any merchant to embed payments. For the Kaveri Drinks project we will use <b>Stripe gateway</b>. It is also possible to store the card on the platform to facilitate subsequent payments. For invoice generation, we use the merchant service, or our own company - <b>inwise.app</b>.&nbsp;'
//           }
//         },
//         {
//           id: 'V3sV3Wu69l',
//           type: 'paragraph',
//           data: {
//             text: 'For delivery cost and time estimations we might need to make an advanced research and match providers requirements.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'Dxx1G-3snM',
//           type: 'header',
//           data: {
//             text: '3.6. Database',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'lwi7ELTX4v',
//           type: 'paragraph',
//           data: {
//             text: 'The data is stored on the secure system of our provider based.io (see 3.4.). The stored data is in JSON format and can be accessed at any time. At the same time it is possible to save in XML, CSV, XSL and any other open file formats.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'CN4AK-jozw',
//           type: 'header',
//           data: {
//             text: '3.7. SEO',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'd_14x46WSq',
//           type: 'paragraph',
//           data: {
//             text: 'Besides tailoring the content, we take into account both international norms and Google\'s recommended practices for optimising site indexing. Furthermore, we’ve incorporated:',
//             style: 'unordered',
//             items: [
//               'schema.org - displaying products and information directly in search results',
//               'Google Webmaster and SEO tools'
//             ]
//           }
//         },
//         {
//           id: 'BgDU7Xmrgz',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               'schema.org - displaying products and information directly in search results',
//               'Google Webmaster and SEO tools'
//             ],
//             text: '4. CMS',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: '59lPyBaIFJ',
//           type: 'header',
//           data: {
//             text: '4. CMS',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'YyGiX5IFTH',
//           type: 'paragraph',
//           data: {
//             text: 'We provide a comprehensive array of tools and systems designed to facilitate content management on our platform. Here, you\'ll find everything necessary for efficient website management, along with distinctive features that set Symbols apart:',
//             style: 'unordered',
//             items: [
//               'Managing pages and website overall content',
//               'Languages',
//               'File management',
//               'Branding management',
//               'Reusable blocks',
//               'Rich content editor for blog posts and other rich content pages.',
//               'Design and management of products and orders',
//               'Managing keywords and other SEO related content'
//             ]
//           }
//         },
//         {
//           id: 'DXSumn8TR_',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               'Managing pages and website overall content',
//               'Languages',
//               'File management',
//               'Branding management',
//               'Reusable blocks',
//               'Rich content editor for blog posts and other rich content pages.',
//               'Design and management of products and orders',
//               'Managing keywords and other SEO related content'
//             ],
//             text: '4.1. Analytics',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'QKV6sLCAV_',
//           type: 'header',
//           data: {
//             text: '4.1. Analytics',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: '0GlCqDUk73',
//           type: 'paragraph',
//           data: {
//             text: 'There are many ways to use analytics. In addition to visitor traffic statistics, Symbols soon will offer detailed analytics including:',
//             style: 'unordered',
//             items: [
//               'User Demographic Statistics',
//               'Visitor activity',
//               'Page usage analytics',
//               'UX analytics',
//               'Analytics on website changes',
//               'We are working on A/B analytics'
//             ]
//           }
//         },
//         {
//           id: 'jeEQ1yzdFK',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               'User Demographic Statistics',
//               'Visitor activity',
//               'Page usage analytics',
//               'UX analytics',
//               'Analytics on website changes',
//               'We are working on A/B analytics'
//             ],
//             text: 'It is also possible to integrate any other tool, for example:'
//           }
//         },
//         {
//           id: 'ONNtiUAOqA',
//           type: 'paragraph',
//           data: {
//             text: 'It is also possible to integrate any other tool, for example:',
//             style: 'unordered',
//             items: [
//               'Google Analytics',
//               'Fullstory',
//               'Mixpanel',
//               'Heep',
//               'Facebook Pixel',
//               'Plausible და სხვები'
//             ]
//           }
//         },
//         {
//           id: 'cdkM3lxMdT',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               'Google Analytics',
//               'Fullstory',
//               'Mixpanel',
//               'Heep',
//               'Facebook Pixel',
//               'Plausible და სხვები'
//             ],
//             text: '4.2. Integrations',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'KQs2dqhrVY',
//           type: 'header',
//           data: {
//             text: '4.2. Integrations',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'X3SP6jyQ2k',
//           type: 'paragraph',
//           data: {
//             text: 'Symbols supports the integration of any 3rd party tool. We help streamline processes and automations, and you can easily use tools like:',
//             style: 'unordered',
//             items: [
//               'Google Workspace products',
//               'Airtable',
//               'Intercom',
//               'Typeform&nbsp;',
//               'Zapier and others'
//             ]
//           }
//         },
//         {
//           id: 'qlqyWP0TJq',
//           type: 'list',
//           data: {
//             style: 'unordered',
//             items: [
//               'Google Workspace products',
//               'Airtable',
//               'Intercom',
//               'Typeform&nbsp;',
//               'Zapier and others'
//             ],
//             text: '5. Price',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'qpTVsvNeOw',
//           type: 'header',
//           data: {
//             text: '5. Price',
//             level: 3,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'Uq-DkVTgoC',
//           type: 'paragraph',
//           data: {
//             text: 'Upon advancing with the website, we present you with two payment options.',
//             style: 'ordered',
//             items: [
//               'The service within the total price is <b>USD 16,850.00</b>, which includes initial product manufacturing, 1 year of personal technical support and consulting, bug fixes and 3 years of free use of our platform with the enterprise package, which includes:',
//               'Unlimited team member addition support',
//               'Support on Analytics integration',
//               'Updates and support additional functionalities for existing packages',
//               'Priority support on new features and feature-requests',
//               'Dedicated assistance from our team members for 48 hours post-project delivery.'
//             ]
//           }
//         },
//         {
//           id: 'IlakofPKr4',
//           type: 'list',
//           data: {
//             style: 'ordered',
//             items: [
//               'The service within the total price is <b>USD 16,850.00</b>, which includes initial product manufacturing, 1 year of personal technical support and consulting, bug fixes and 3 years of free use of our platform with the enterprise package, which includes:',
//               'Unlimited team member addition support',
//               'Support on Analytics integration',
//               'Updates and support additional functionalities for existing packages',
//               'Priority support on new features and feature-requests',
//               'Dedicated assistance from our team members for 48 hours post-project delivery.'
//             ]
//           }
//         },
//         {
//           id: 'tommgJ4xwp',
//           type: 'list',
//           data: {
//             style: 'ordered',
//             items: [
//               'In adherence to the distributed agreement, the singular charge for site development amounts to <b>USD 11,900.00</b>. Additionally, the monthly platform membership fee starts at <b>USD 39.00</b>, encompassing all the advantages detailed in the aforementioned section. Failure to settle the monthly fee won`t lead to website deactivation;however, you will be transitioned to a free package on the platform, with your status contingent upon Symbols’ prevailing policies.',
//               'Furthermore, should we incorporate advanced animations and 3D motion into the website (see 2.5.2.), there will be an additional cost of <b>USD 8,500-16,800.00</b> and additional 2-4 weeks depend on complexity. This would bring the base total cost to USD 25,350 for option 5.1. and USD 20,400 for option 5.2.'
//             ],
//             text: 'Our payment condition is to pay 40% of the service amount in advance, and the remaining 60% after the completion of the service and signing of acceptance. After payment, we will give you access to the product code and the full functionality of the platform management account. If you wish, you can run the site on other vendors, but in this case we cannot guarantee its uninterrupted operation.'
//           }
//         },
//         {
//           id: 'bYY2XiQSsC',
//           type: 'paragraph',
//           data: {
//             text: 'Our payment condition is to pay 40% of the service amount in advance, and the remaining 60% after the completion of the service and signing of acceptance. After payment, we will give you access to the product code and the full functionality of the platform management account. If you wish, you can run the site on other vendors, but in this case we cannot guarantee its uninterrupted operation.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'irWY10N8Dx',
//           type: 'header',
//           data: {
//             text: '5.3. Terms',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'EgxoKlKeYS',
//           type: 'paragraph',
//           data: {
//             text: 'Typically, it takes about a month to make the site operational, allowing it to be accessed by the general public. However, an additional two-week period might be required for comprehensive testing and troubleshooting. If more technical challenges arise, Symbols is prepared to provide technical support not only during the initial year after delivery but also for as long as the customer remains an active member of the platform.'
//           }
//         },
//         {
//           id: 'hmBqEd9mp6',
//           type: 'paragraph',
//           data: {
//             text: 'Following a month of activity, upon your request, we will carry out a 2-week UX analysis focused on user behaviour (refer to section 2.7). The aim is to proactively address unforeseen issues and enhance the site\'s usability. This analysis is not intended to result in any additional expenses.',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'wf-DLO5NXN',
//           type: 'header',
//           data: {
//             text: '5.4. Additional Services',
//             level: 4,
//             alignment: 'left'
//           }
//         },
//         {
//           id: 'XG2zolqbz8',
//           type: 'paragraph',
//           data: {
//             text: 'Upon finishing the initial phase, there\'s an opportunity for voluntary cooperation aimed at product expansion and enhancing user experience. The Symbols team can offer engaged consultants to assist in the enhancement of the site\'s content and information architecture.'
//           }
//         },
//         {
//           id: 'dCMiE4GN72',
//           type: 'paragraph',
//           data: {
//             text: 'Furthermore, we extend the option of product photography, which is not covered by the website\'s pricing. Our affiliated entity, <b>Snapshot</b>, specialises in capturing product images both against a white backdrop and in the composition, ensuring optimal preparation for online presentation.'
//           }
//         }
//         ]
//       }
//     },
//     '/components': ComponentsPage
//   }
// })

import * as smbls from 'smbls'
if (window.packages) {
  window.packages.smbls = () => smbls
} else {
  window.packages = { smbls: () => smbls }
}
window.require = (key) => {
  const pkg = window.packages[key]
  if (typeof pkg === 'function') return pkg()
  else return pkg
}

// import init, { js_domql_string_to_react_string, initSync } from './dompiler'

// export async function convertDomqlToReact (domqlString) {
//   await init() // Ensure the WASM module is initialized
//   try {
//     const reactString = js_domql_string_to_react_string(domqlString)
//     console.log(reactString) // Output the converted React string
//   } catch (error) {
//     console.error('Error converting DOMQL to React:', error)
//   }
// }

// // Example DOMQL string
// const domqlString = `export const IconText = {
//   extend: "Flex",

//   props: {
//     align: "center center",
//     lineHeight: 1,
//   },

//   Icon: {
//     props: ({ parent }) => ({ icon: parent.props.icon }),
//     if: ({ parent, props }) => {
//       const doesExist =
//         parent.props.icon || parent.props.Icon || props.name || props.icon;
//       return doesExist;
//     },
//   },

//   text: ({ props }) => props.text,
// };`

// convertDomqlToReact(domqlString)
